// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1f-ZL","legacyBtn":"MutateMid_legacyBtn__12zS6"};